import { call, put, takeLatest } from 'redux-saga/effects'
import { navigate } from '@reach/router'

// redux
import * as sefFormModule from '../modules/sefForms'
import * as sefApi from '../apiModules/sef'

function* createForm({ payload }) {
  try {
    yield call(sefApi.createForm, payload)
    yield put(sefFormModule.createFormSuccess())

    navigate(`/dashboard/forms`)
  } catch (err) {
    yield put(sefFormModule.createFormFailure(err.response.data))
  }
}

function* deleteForm({ payload }) {
  try {
    const { formId } = payload
    yield call(sefApi.deleteForm, { formId })
    yield put(sefFormModule.deleteFormSuccess())

    navigate(`/dashboard/forms`)
  } catch (err) {
    yield put(sefFormModule.deleteFormFailure())
  }
}

function* fetchForm({ payload }) {
  try {
    const response = yield call(sefApi.fetchForm, payload)
    yield put(sefFormModule.fetchFormSuccess(response))
  } catch (err) {
    yield put(sefFormModule.fetchFormFailure(err))
  }
}

function* fetchFormAnswers({ payload }) {
  try {
    const response = yield call(sefApi.fetchFormAnswers, payload)
    yield put(sefFormModule.fetchFormAnswersSuccess(response))
  } catch (err) {
    yield put(sefFormModule.fetchFormAnswersFailure(err))
  }
}

function* fetchForms({ payload }) {
  try {
    const response = yield call(sefApi.fetchForms, payload)
    yield put(sefFormModule.fetchFormsSuccess(response))
  } catch (err) {
    yield put(sefFormModule.fetchFormsFailure(err))
  }
}

function* updateForm({ payload }) {
  try {
    const updatedForm = yield call(sefApi.updateForm, payload)
    yield put(sefFormModule.updateFormSuccess(updatedForm))

    navigate(`/dashboard/forms/`)
  } catch (err) {
    yield put(sefFormModule.updateFormFailure())
  }
}

export const sefFormsSagas = [
  takeLatest(sefFormModule.CREATE_FORM, createForm),
  takeLatest(sefFormModule.DELETE_FORM, deleteForm),
  takeLatest(sefFormModule.FETCH_FORM, fetchForm),
  takeLatest(sefFormModule.FETCH_FORM_ANSWERS, fetchFormAnswers),
  takeLatest(sefFormModule.FETCH_FORMS, fetchForms),
  takeLatest(sefFormModule.UPDATE_FORM, updateForm)
]
